import React from 'react';
import { Typography, Box } from '@mui/material';

interface KilometerDetailsProps {
  tripDays: number;
  distanceDetails?: {
    kmPrice: number;
    dayPrice: number;
    finalPrice: number;
    baseKmLimit: number;
    extraKm: number;
    baseKmPrice: number;
    extraKmPrice: number;
  };
  calculatedDistance?: number;
}

const KilometerDetails: React.FC<KilometerDetailsProps> = ({
  tripDays,
  distanceDetails,
  calculatedDistance
}) => {
  return (
    <Box sx={{ mb: 2, backgroundColor: 'rgba(0,150,136,0.1)', p: 1.5, borderRadius: 1, border: '1px solid rgba(0,150,136,0.3)', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#009688', mb: 0.5, fontSize: '1rem' }}>
        Kilometer Details:
      </Typography>
      
      {/* Total Kilometers for the trip */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" sx={{ color: '#e0e0e0', fontSize: '0.85rem' }}>
          Total Kilometer Limit:
        </Typography>
        <Typography variant="body2" sx={{ color: '#009688', fontSize: '0.85rem', fontWeight: 'bold' }}>
          {(() => {
            // Calculate daily limit
            const dailyLimit = (() => {
              if (distanceDetails && distanceDetails.baseKmLimit) {
                return Math.round(distanceDetails.baseKmLimit / tripDays);
              }
              return 300; // Default value
            })();
            return `${dailyLimit} KM × ${tripDays} days = ${dailyLimit * tripDays} KM`;
          })()}
        </Typography>
      </Box>
      
      {/* Actual Total Distance */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" sx={{ color: '#e0e0e0', fontSize: '0.85rem' }}>
          Actual Total Distance:
        </Typography>
        <Typography variant="body2" sx={{ color: '#009688', fontSize: '0.85rem', fontWeight: 'bold' }}>
          {calculatedDistance ? `${Math.round(calculatedDistance)} KM` : '0 KM'}
        </Typography>
      </Box>
      
      {/* Extra Kilometers */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" sx={{ color: '#e0e0e0', fontSize: '0.85rem' }}>
          Extra Kilometers:
        </Typography>
        <Typography variant="body2" sx={{ color: '#009688', fontSize: '0.85rem', fontWeight: 'bold' }}>
          {(() => {
            // Calculate total kilometers based on daily limit * days
            const dailyLimit = (() => {
              if (distanceDetails && distanceDetails.baseKmLimit) {
                return Math.round(distanceDetails.baseKmLimit / tripDays);
              }
              return 300; // Default value
            })();
            const totalLimit = dailyLimit * tripDays;
            const actualDistance = calculatedDistance ? Math.round(calculatedDistance) : 0;
            const extraKm = actualDistance - totalLimit;
            return extraKm > 0 ? extraKm : 0;
          })()} KM
        </Typography>
      </Box>
    </Box>
  );
};

export default KilometerDetails;
